/* tslint:disable */
/* eslint-disable */
export enum AccountQuoteRequestAdditionalPaymentTypeEnum {
  None = 'None',
  Additional = 'Additional',
  Regular = 'Regular'
}
